import { ArrowUpRight, CircleAlert, Network, Orbit, UserRound } from "lucide-react";
import type { NarratorRecord } from "../types";

type Props = {
  person: NarratorRecord;
  connectionCount: number;
};

const dimensionFor = (person: NarratorRecord) => {
  const centrality = person.importance_tier === 1 ? 4 : person.importance_tier === 2 ? 3 : 2;
  const proximity = person.role.includes("participant") || person.role.includes("survivor") ? 4 : person.id === "person.abu-mikhnaf" ? 2 : 1;
  const identity = person.importance_tier === 4 ? 1 : person.importance_tier === 3 ? 2 : 3;
  return { centrality, proximity, identity };
};

function Meter({ label, value }: { label: string; value: number }) {
  return (
    <div className="meter-row">
      <div className="meter-copy"><span>{label}</span><b>{value}/4</b></div>
      <div className="meter-track"><i style={{ width: `${value * 25}%` }} /></div>
    </div>
  );
}

export function EvidenceInspector({ person, connectionCount }: Props) {
  const dimensions = dimensionFor(person);
  return (
    <aside className="evidence-inspector" aria-live="polite">
      <div className="inspector-heading">
        <div>
          <span className="inspector-index">P{person.importance_tier}</span>
          <h2>{person.display_name}</h2>
        </div>
        <ArrowUpRight size={18} />
      </div>
      <p className="inspector-bio">{person.mini_bio}</p>
      <dl className="fact-list">
        <div><UserRound size={15} /><dt>Role</dt><dd>{person.role}</dd></div>
        <div><Orbit size={15} /><dt>Death</dt><dd>{person.death ?? "Unknown"}</dd></div>
        <div><Network size={15} /><dt>Visible connections</dt><dd>{connectionCount}</dd></div>
      </dl>
      <div className="evidence-profile">
        <h3>Evidence profile</h3>
        <Meter label="Corpus centrality" value={dimensions.centrality} />
        <Meter label="Event proximity" value={dimensions.proximity} />
        <Meter label="Identity security" value={dimensions.identity} />
      </div>
      <div className="inspector-caution">
        <CircleAlert size={16} />
        <p>{person.relevance}</p>
      </div>
      <p className="inspector-footnote">Importance measures research priority, never blanket reliability.</p>
    </aside>
  );
}
